document.addEventListener("DOMContentLoaded", function () {
  document.getElementById("customForm").addEventListener("submit", function (event) {
      event.preventDefault();
    //alert(2);
      let isValid = !0;
      document
        .querySelectorAll(".error-message")
        .forEach((el) => (el.style.display = "none")),
        document
          .querySelectorAll(
            ".custom-form-container input, .custom-form-container select"
          )
          .forEach((input) => input.classList.remove("error")),
        document.querySelectorAll(".form-group").forEach((group) => {
          let input = group.querySelector("input, select"),
            errorMessage = group.querySelector(".error-message");
          !input || input.value.trim() === ""
            ? (errorMessage && (errorMessage.style.display = "block"),
              input && input.classList.add("error"),
              (isValid = !1))
            : (errorMessage && (errorMessage.style.display = "none"),
              input && input.classList.remove("error"));
        });
      let phoneInput = document.getElementById("phone"),
        phoneError = phoneInput.nextElementSibling,
        phoneValue = phoneInput.value.trim();
      if (
        (!/^\d{6,12}$/.test(phoneValue) ||
        ![6, 7, 8, 9, 10, 11, 12].includes(phoneValue.length)
          ? ((phoneError.style.display = "block"),
            phoneInput.classList.add("error"),
            (isValid = !1))
          : ((phoneError.style.display = "none"),
            phoneInput.classList.remove("error")),
        !!isValid)
      ) {
        var data = {
          name: document.getElementById("shopName").value.trim(),
          yourName: document.getElementById("yourName").value.trim(),
          email: document.getElementById("email").value.trim(),
          phone: phoneValue,
          city: document.getElementById("city").value.trim(),
          state: document.getElementById("state").value.trim(),
          country: document.getElementById("country").value.trim(),
          tshirtSize: document.getElementById("tshirtSize").value.trim(),
        };
        $.ajax({
          type: "POST",
          url: "/apps/b2c_demo/submission.php",
          data,
          dataType: "json",
          success: function (data2) {
            data2.status == "success" &&
              ($(".form_scs").show(),
              $(".form_norms").hide(),
              $(".custom-form-container").addClass("form-submitted-sucess"),
              $("html, body").animate(
                { scrollTop: $(".demo-rich-text").offset().top },
                500
              ));
          },
        }),
          $("input#Shop_Name_01JKFT5EK9R8MXHFXRFG6RMXMH").val("ssss");
      }
    }),
    document.getElementById("phone").addEventListener("input", function () {
      (this.value = this.value.replace(/\D/g, "").slice(0, 12)),
        validatePhoneNumber();
    });
  function validatePhoneNumber() {
    let phoneInput = document.getElementById("phone"),
      phoneError = phoneInput.nextElementSibling,
      phoneValue = phoneInput.value.trim();
    !/^\d{6,12}$/.test(phoneValue) ||
    ![6, 7, 8, 9, 10, 11, 12].includes(phoneValue.length)
      ? ((phoneError.style.display = "block"),
        phoneInput.classList.add("error"))
      : ((phoneError.style.display = "none"),
        phoneInput.classList.remove("error"));
  }
  document
    .querySelectorAll(
      ".custom-form-container input, .custom-form-container select"
    )
    .forEach((input) => {
      input.addEventListener("input", function () {
        if (this.value.trim() !== "") {
          this.classList.remove("error");
          let errorMessage = this.parentElement.querySelector(".error-message");
          errorMessage && (errorMessage.style.display = "none");
        }
      });
    });
});
